export const resolveBrowserZoneId = () => {
  if (typeof window === "undefined") {
    return undefined;
  }

  try {
    const zoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return zoneId || undefined;
  } catch {
    return undefined;
  }
};
